<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-main-sidebar></app-main-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar =  !isSidebar"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <form @submit.prevent="ReferenceForm">
          <div class="container-fluid mt-5">
            <div class="col-sm-12">
              <div
                class="row dblock"
                style="padding: 5px;box-shadow: 0 0 15px 0 rgba(0,0,0,.05);"
              >
                <div class="row">
                  <div class="col-md-12">
                    <vs-breadcrumb
                      align="left"
                      :items="
                  [
                    {title: 'You are here : '},
                     {
                    title: 'Dashboard',
                    url: '/#/dashboard/trainee/traineeDashboard',
                    active: false
                  },
                    {
                      title: 'Add Reference',
                      url: '/#/dashboard/Trainee/postassessment',
                      active: true
                    }
                  ]"
                    ></vs-breadcrumb>
                    <div class="heading mt-3">
                      <h3 class="text-secondary">Reference</h3>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-row" v-if="show_blog == true">
                    <h6 class="sub-frm-title">Add Reference(s)</h6>
                    <div class="col-sm-12">
                      <b-card
                        v-if="isForm "
                        style="border: 1px dotted #07a7e14f;"
                      >
                        <div class="form-group">
                          <div>
                            <b
                            v-if="show_blog == true"
                              :class="referenceCount == 2 ?  'msg-success' : 'msg-danger' "
                            >
                              You have added {{ this.referenceCount }} out of 2
                              Reference(s) to this Training
                            </b>
                          </div>

                          <div class="row">
                            <div
                              class="col-md-6 col-lg-6"
                              style="margin-top:30px;"
                            >
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  type="text"
                                  v-model="name"
                                  placeholder=" "
                                  autocomplete="off"
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >person</i
                                  >
                                </span>

                                <label class="lbl-label">
                                  Name
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                              </div>
                            </div>

                            <div
                              class="col-md-6 col-lg-6"
                              style="margin-top:30px;"
                            >
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-model="organization"
                                  type="text"
                                  placeholder=" "
                                  autocomplete="off"
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >account_balance</i
                                  >
                                </span>

                                <label class="lbl-label">
                                  Organization/Department
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                              </div>
                            </div>

                            <!-- floating input ends -->
                            <div
                              class="col-md-6 col-lg-6"
                              style="margin-top:30px;"
                            >
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-mask="'(9999) 9999999'"
                                  v-model="contactno"
                                  type="text"
                                  placeholder=" "
                                  autocomplete="off"
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >call</i
                                  >
                                </span>

                                <label class="lbl-label">
                                  Contact Number (Mobile Number)
                                  <span style="color:rgba(255, 0, 0, 0.78);"
                                    >*</span
                                  >
                                </label>
                              </div>
                            </div>

                            <!-- floating input ends -->
                            <div
                              class="col-md-6 col-lg-6"
                              style="margin-top:30px;"
                            >
                              <div class="floating-label">
                                <input
                                  class="floating-input form-control"
                                  v-model="email"
                                  type="email"
                                  placeholder=" "
                                />

                                <span
                                  class="lbl-label"
                                  style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                >
                                  <i
                                    class="material-icons"
                                    style="font-size: 20px;"
                                    >email</i
                                  >
                                </span>

                                <label class="lbl-label">Email Address</label>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <label style="color: #07a7e19c !important;">
                                Relation
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                              <selectize
                                id="select-state"
                                class="text-capitalize"
                                v-model="relation"
                                :settings="relationSettings"
                                :searchable="true"
                              >
                                <option
                                  v-for="(item,index) in relationArr"
                                  :key="index"
                                  :value="item.id"
                                  class="text-capitalize"
                                >
                                  {{item.title}}
                                </option>
                              </selectize>
                            </div>
                            <div class="col-sm-6">
                              <label style="color: #07a7e19c !important;">
                                Designation
                                <span style="color:rgba(255, 0, 0, 0.78);"
                                  >*</span
                                >
                              </label>
                              <selectize
                                id="select-state"
                                class="text-capitalize"
                                v-model="designation"
                                :settings="designationSettings"
                                :searchable="true"
                              >
                                <option
                                  v-for="(item,index) in designationArr"
                                  :key="index"
                                  :value="item.id"
                                  class="text-capitalize"
                                >
                                  {{item.title}}
                                </option>
                              </selectize>
                            </div>
                          </div>
                        </div>

                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-12">
                              <!-- add button starts-->

                              <b-button
                                type="submit"
                                class="ref-btn"
                                variant="primary"
                                :disabled="referenceCount == 2"
                                >Add Reference</b-button
                              >
                              <!-- add button ends -->
                            </div>
                          </div>
                        </div>
                      </b-card>
                     
                    </div>
                  </div>
                  <div class="form-row" v-if="isEditForm">
                    <h6 class="sub-frm-title">Update Reference(s)</h6>
                    <div class="col-sm-12">
                  <b-card
                        
                        style="border: 1px dotted #07a7e14f;"
                      >
                        <form @submit.prevent="submitEditForm">
                          <div class="form-group">
                            <div class="row">
                              <div
                                class="col-md-6 col-lg-6"
                                style="margin-top:30px;"
                              >
                                <div class="floating-label">
                                  <input
                                    class="floating-input form-control"
                                    type="text"
                                    v-model="name"
                                    placeholder=" "
                                  />

                                  <span
                                    class="lbl-label"
                                    style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                  >
                                    <i
                                      class="material-icons"
                                      style="font-size: 20px;"
                                      >person</i
                                    >
                                  </span>
                                  <label class="lbl-label">Name</label>
                                </div>
                              </div>

                              <div
                                class="col-md-6 col-lg-6"
                                style="margin-top:30px;"
                              >
                                <div class="floating-label">
                                  <input
                                    class="floating-input form-control"
                                    v-model="organization"
                                    type="text"
                                    placeholder=" "
                                  />

                                  <span
                                    class="lbl-label"
                                    style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                  >
                                    <i
                                      class="material-icons"
                                      style="font-size: 20px;"
                                      >account_balance</i
                                    >
                                  </span>
                                  <label class="lbl-label">organization</label>
                                </div>
                              </div>

                              <!-- floating input ends -->
                              <div
                                class="col-md-6 col-lg-6"
                                style="margin-top:30px;"
                              >
                                <div class="floating-label">
                                  <input
                                    class="floating-input form-control"
                                    v-mask="'(9999) 9999999'"
                                    v-model="contactno"
                                    type="text"
                                    placeholder=" "
                                    autocomplete="off"
                                  />

                                  <span
                                    class="lbl-label"
                                    style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                  >
                                    <i
                                      class="material-icons"
                                      style="font-size: 20px;"
                                      >call</i
                                    >
                                  </span>
                                  <label class="lbl-label"
                                    >Contact Number (Mobile Number)</label
                                  >
                                </div>
                              </div>

                              <!-- floating input ends -->
                              <div
                                class="col-md-6 col-lg-6"
                                style="margin-top:30px;"
                              >
                                <div class="floating-label">
                                  <input
                                    class="floating-input form-control"
                                    v-model="email"
                                    type="text"
                                    placeholder=" "
                                  />

                                  <span
                                    class="lbl-label"
                                    style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                                  >
                                    <i
                                      class="material-icons"
                                      style="font-size: 20px;"
                                      >email</i
                                    >
                                  </span>
                                  <label class="lbl-label">Email Address</label>
                                </div>
                              </div>
                              <div class="col-sm-6">
                                <label>Relation</label>
                                <selectize
                                  id="select-state"
                                  class="text-capitalize"
                                  v-model="relation"
                                  :settings="relationSettings"
                                  :searchable="true"
                                >
                                  <option
                                    v-for="(item,index) in relationArr"
                                    :key="index"
                                    :value="item.id"
                                    class="text-capitalize"
                                  >
                                    {{item.title}}
                                  </option>
                                </selectize>
                              </div>
                              <div class="col-sm-6">
                                <label>Designation</label>
                                <selectize
                                  id="select-state"
                                  class="text-capitalize"
                                  v-model="designation"
                                  :settings="designationSettings"
                                  :searchable="true"
                                >
                                  <option
                                    v-for="(item,index) in designationArr"
                                    :key="index"
                                    :value="item.id"
                                    class="text-capitalize"
                                    :search="true"
                                  >
                                    {{item.title}}
                                  </option>
                                </selectize>
                              </div>
                            </div>
                          </div>
                          <input type="hidden" v-model="referenceId" />
                          <div class="form-group">
                            <div class="row">
                              <div class="col-sm-12">
                                <!-- add button starts-->
                                <b-button
                                  pill
                                  type="submit"
                                  class="ref-btn"
                                  variant="primary"
                                  >Update</b-button
                                >
                                <b-button
                                  pill
                                  v-if="!isForm"
                                  @click="closeEditForm"
                                  variant="outline-info"
                                  >Cancel</b-button
                                >
                                <!-- add button ends -->
                              </div>
                            </div>
                          </div>
                        </form>
                      </b-card>
                      </div>
                      </div>
                  <!--Traning Referance -->

                  <div class="col-sm-12 mt-3" v-if="show_blog == true">
                    <h6 class="table-title">
                      Training {{this.trainingTitle}} Reference(s)
                    </h6>
                    <b-card>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="table-responsive">
                              <table class="table table-hover">
                                <tr>
                                  <th>Sr#</th>
                                  <th>Name</th>
                                  <th>Designation</th>
                                  <th>Email ID</th>
                                  <th>Contact Number</th>
                                  <th>Action</th>
                                </tr>
                                <tr
                                  v-for="(item, index) in traingRef"
                                  v-bind:key="item.id"
                                >
                                  <td>{{index+1}}</td>
                                  <td class="text-capitalize">
                                    {{item.name}}
                                  </td>
                                  <td>
                                    {{ getDesignationTitle(item.designation_id) }}
                                  </td>

                                  <td v-if="item.email != null">
                                    {{item.email}}
                                  </td>
                                  <td v-else>--</td>
                                  <td>{{item.contactNo}}</td>
                                  <td>
                                    

                                    <a @click="deleteRecord(item.id)">
                                      <vs-icon
                                        class="ml-2"
                                        icon="delete"
                                        style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                      ></vs-icon>
                                    </a>
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card>
                  </div>

                  <!--All Referances -->
                  <div class="col-sm-12 mt-3">
                    <h6 class="table-title">All Reference(s)</h6>
                    <!-- new form popup starts -->
                    <b-card>
                      <div class="form-group">
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="table-responsive">
                              <table class="table table-hover">
                                <tr>
                                  <th>Sr#</th>
                                  <th>Name</th>
                                  <th>Designation</th>
                                  <th>Email ID</th>
                                  <th>Contact Number</th>
                                  <th>Action</th>
                                  <th v-if="show_blog == true">Add</th>
                                </tr>
                                <tr
                                  v-for="(item, index) in items"
                                  v-bind:key="item.id"
                                >
                                  <td>{{index+1}}</td>
                                  <td class="text-capitalize">{{item.name}}</td>

                                  <td>
                                    {{ getDesignationTitle(item.designation_id) }}
                                  </td>
                                  <td>{{item.email}}</td>
                                  <td>{{item.contactNo}}</td>
                                  <td>
                                    <a @click="editRecord(item.id)">
                                      <vs-icon
                                        class="mr-2"
                                        icon="edit"
                                        style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                      ></vs-icon>
                                    </a>
                                  </td>
                                  <td v-if="show_blog == true">
                                    <b-button
                                      v-if="item.training_id != training_id"
                                      class="add-ref"
                                      variant="primary"
                                      :disabled="referenceCount == 2"
                                      @click="addReference(item.id)"
                                      >Add
                                    </b-button>
                                    <!--
                                    <a @click="deleteRecord(item.id)">
                                      <vs-icon
                                        class="ml-2"
                                        icon="delete"
                                        style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                      ></vs-icon>
                                    </a>
                                    -->
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </b-card>
                    <!-- new form popup ends -->
                  </div>
                </div>
                <!-- save button starts-->
                <!-- <a href="#" class="ref-btn btn btn-info">Save</a> -->
                <!-- <a href="#" class="btn btn-secondary float-right mr-2">Add New</a> -->

                <!-- save button ends -->
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import MainSidebar from "./main-sidebar";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import Selectize from "vue2-selectize";


// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
  data: () => ({
    error: "",
    success: "",
    title: "",
    name: "",
    referenceId: "",
    contactno: "",
    organization: "",
    email: "",
    isSidebar: false,
    isForm: true,
    isEditForm: false,
    isFormData: false,
    relation: "",
    designation: "",
    relationSettings: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select Reference"
    },
    designationSettings: {
      maxItems: 1,
      searchField: ["text"],
      plugins: ["remove_button"],
      placeholder: "Select Designation"
    },

    relationArr: [],
    designationArr: [],
    items: [],
    referenceCount:0,
    training_id: '',
    traingRef:[],
    trainingTitle:'',
    show_blog: false,
  }),
   mounted() {
    const url = window.location.href;
      if (url.includes("dashboard/Trainee/addReference?training=")) {
        this.show_blog = true;
      } else if (url.includes("dashboard/Trainee/addReference")) {
        this.show_blog = false;
      }
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
     this.allReferences();
     this.getDesignations();
     this.training_id = this.$route.query?.training?.id ?? '' ;
     this.trainingTitle = this.$route.query?.training?.title ?? '' ;
     this.traingReferences();
     this.openLoading();
    axios
      .get(process.env.VUE_APP_BASE_PATH + "/relation/get/all"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.relationArr = response.data;
      });
     this.getReferenceCount()

  },
  //

  components: {
    "app-navbar": Navbar,
    "app-main-sidebar": MainSidebar,
    Selectize
  },

  methods: {
    getDesignations(){
      axios
      .get(process.env.VUE_APP_BASE_PATH + "/trainee-designation/get/all"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.designationArr = response.data;
      });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    closeEditForm() {
      this.isForm = true;
      this.isEditForm = false;
      this.name = "";
      this.organization = "";
      this.contactno = "";
      this.email = "";
      this.relation = "";
      this.designation = "";
    },
    editRecord(id) {
      this.isForm = false;
      this.isEditForm = true;
      this.openLoading();
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/references/get/single/" + id
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.name = response.data.name;
            this.contactno = response.data.contactNo;
            this.organization = response.data.organization;
            this.email = response.data.email;
            this.referenceId = response.data.id;
            this.designation = response.data.designation_id;
            this.relation = response.data.relation_id;
            this.training_id = response.data.training_id;

            window.scrollTo(0, 0);
          }
        });
    },
    deleteRecord(id) {
      // alert("ID '" +id+ "' is being deleted.");
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(process.env.VUE_APP_BASE_PATH + "/references/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allReferences();
                  this.traingReferences();
                  this.getReferenceCount();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    //function used to show all records in table
    allReferences: function allReferences() {
      axios
        .get(process.env.VUE_APP_BASE_PATH + "/references/get/"+JSON.parse(localStorage.getItem("currentUser")).id
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.items = response.data;
        });
    },
    ReferenceForm(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.organization) {
        this.inValid.push("Organization is required.");
      }
       var phone_no1 = this.contactno;
      if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
         if (phone_no1.length < 14 || !phone_no1.startsWith('(03')) {
          this.inValid.push("Must be a valid number starting with '03', e.g., 0345-9992229");
        }
      }
      if (!this.relation) {
        this.inValid.push("Please select relation.");
      }
      if (!this.designation) {
        this.inValid.push("Please select designation.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/references/add", {
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            training_id: this.training_id,
            name: this.name,
            contactno: this.contactno,
            organization: this.organization,
            designation: this.designation,
            relation: this.relation,
            email: this.email,

          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been saved successfully!");
              self.resetForm();
              self.allReferences();
              self.getReferenceCount();
              self.traingReferences();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    // This will submit form
    submitEditForm(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.organization) {
        this.inValid.push("Organization is required.");
      }
       var phone_no1 = this.contactno;
      if (phone_no1 == null || phone_no1 == undefined || phone_no1 == '') {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
         if (phone_no1.length < 14 || !phone_no1.startsWith('(03')) {
          this.inValid.push("Must be a valid number starting with '03', e.g., 0345-9992229");
        }
      }
      if (!this.relation) {
        this.inValid.push("Please select relation.");
      }
      if (!this.designation) {
        this.inValid.push("Please select designation.");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(process.env.VUE_APP_BASE_PATH + "/references/update", {
            name: this.name,
            contactno: this.contactno,
            organization: this.organization,
            email: this.email,
            id: this.referenceId,
            designation: this.designation,
            relation: this.relation,
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            training_id: this.training_id,
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.isForm = true;
              self.isEditForm = false;
              self.toastSuccess("Record has been updated successfully!");
              self.resetForm();
              self.allReferences();
               self.traingReferences();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
     getReferenceCount(){
       axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/references/counts/" +
            this.training_id  + "/" + JSON.parse(localStorage.getItem("currentUser")).id
        )
        .then(response => {
               this.referenceCount = response.data.count
               if(response.data.count >= 2){
                 this.$router.push('/dashboard/Trainee/traineeDashboard');
               }

        })
    },

    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Logo has been Uploaded, consectetur"
      });
    },
    resetForm() {
      this.name = "";
      this.contactno = "";
      this.organization = "";
      this.email = "";
      this.designation ="";
      this.relation ="";
    },
   addReference(id) {
    this.$bvModal
    .msgBoxConfirm("Please confirm that you want to add this reference?", {
      title: "Please Confirm",
      size: "sm",
      buttonSize: "sm",
      okVariant: "primary",
      okTitle: "Add",
      cancelTitle: "Cancel",
      footerClass: "p-2",
      hideHeaderClose: false,
      centered: true
    })
    .then(value => {
      if (value === true) {
        this.openLoading();
        axios
          .get(process.env.VUE_APP_BASE_PATH + "/references/get/single/" + id)
          .then(response => {
            if (response.data) {

              axios
                .post(process.env.VUE_APP_BASE_PATH + "/references/add", {
                  user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                  training_id: this.training_id,
                  name: response.data.name,
                  contactno: response.data.contactNo,
                  organization: response.data.organization,
                  designation: response.data.designation_id,
                  relation: response.data.relation_id,
                  email: response.data.email
                })
                .then(response => {
                  this.closeLoading();
                  if (response.data.success) {
                    this.toastSuccess("Record has been saved successfully!");
                    this.resetForm();
                    this.allReferences();
                    this.getReferenceCount();
                    this.traingReferences();
                  } else if (response.data.error) {
                    this.$toasted.global.errorMsg(response.data.error);
                  }
                })
                .catch(error => {
                  this.closeLoading();
                  this.$toasted.global.errorMsg(error);
                });
            }
          })
          .catch(error => {
            this.closeLoading();
            this.$toasted.global.errorMsg(error);
          });
      }
    });
},
   traingReferences(){
    axios
        .get(process.env.VUE_APP_BASE_PATH + "/references/get-assigned-references-to-training/"+JSON.parse(localStorage.getItem("currentUser")).id+"/"+this.training_id
        )
        .then(response => {

          this.traingRef = response.data;
        });
   },
   getDesignationTitle(id) {
      const designation = this.designationArr.find(d => d.id === id);
      return designation ? designation.title : 'Unknown';
    },


  }
};
</script>

<style scoped>
#menu-toggle {
  cursor: pointer;
  font-size: 24px;
  color: rgba(7, 167, 225, 0.61);
  padding: 10px;
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 1000;
  }
  
  #wrapper.toggled #page-content-wrapper {
    margin-left: 0;
  }
}

.dblock {
  display: block !important;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 15px rgba(0,0,0,0.08);
  margin: 20px 0;
  padding: 20px;
}

.input-color {
  margin-bottom: 15px;
  position: relative;
}

.dflex {
  display: flex;
  flex-wrap: wrap;
}

.fcenter {
  justify-content: center;
  align-items: center;
}

.con-select {
  width: 100%;
  margin-bottom: 15px;
}

.form-row {
  padding: 20px;
  color: #1465a3;
  border: 1px solid rgba(7, 167, 225, 0.2);
  border-radius: 8px;
  margin: 15px 0 !important;
  background: #f8fbff;
}

.sub-frm-title {
  padding: 8px 15px;
  background-color: #fff;
  margin-top: -35px;
  display: inline-block;
  border-radius: 20px;
  color: rgba(7, 167, 225, 0.8);
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(7, 167, 225, 0.1);
}

.ref-btn {
  padding: 8px 20px;
  font-size: 14px;
  border-radius: 6px;
  background: rgba(7, 167, 225, 0.8) !important;
  border: none;
  color: white;
  transition: all 0.3s ease;
  margin: 10px 5px;
  float: right;
}

.ref-btn:hover {
  background: rgba(7, 167, 225, 1);
  transform: translateY(-1px);
}

.table-responsive {
  margin: 15px 0;
  border-radius: 8px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  background: #fff;
  box-shadow: 0 2px 15px rgba(0,0,0,0.08);
}

.table {
  margin-bottom: 0;
  min-width: 800px; /* Ensures table maintains minimum width on mobile */
}

.table th {
  background: rgba(7, 167, 225, 0.1);
  color: rgba(7, 167, 225, 0.8);
  font-weight: 600 !important;
  border-top: none;
  padding: 12px !important;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 1;
}

.table td {
  padding: 12px !important;
  vertical-align: middle;
  color: #555;
  border-top: 1px solid rgba(0,0,0,0.05);
}

.floating-label {
  position: relative;
  margin-bottom: 20px;
}

.floating-input {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.floating-input:focus {
  border-color: rgba(7, 167, 225, 0.6);
  box-shadow: 0 0 0 3px rgba(7, 167, 225, 0.1);
}

label.lbl-label {
  color: #888;
  font-size: 13px;
  position: absolute;
  pointer-events: none;
  left: 15px;
  top: 10px;
  transition: 0.2s ease all;
  background: #fff;
  padding: 0 5px;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  top: -10px;
  font-size: 12px;
  color: rgba(7, 167, 225, 0.8);
}

.add-ref {
  padding: 5px 15px;
  font-size: 13px;
  border-radius: 4px;
  background: rgba(7, 167, 225, 0.8);
  border: none;
}

.table-title {
  font-size: 16px;
  font-weight: 600;
  color: rgba(7, 167, 225, 0.8);
  margin: 20px 0 10px;
}

.msg-danger {
  font-size: 14px;
  color: #dc3545;
  padding: 5px 0;
}

.msg-success {
  font-size: 14px;
  color: #28a745;
  padding: 5px 0;
}

/* Mobile specific table styles */
@media (max-width: 576px) {
  .table-responsive {
    margin: 10px -15px;
    width: calc(100% + 30px);
    border-radius: 0;
    box-shadow: none;
  }
  
  .table {
    font-size: 13px;
  }
  
  .table th,
  .table td {
    padding: 10px 8px !important;
  }

  /* Add horizontal scroll indicator */
  .table-responsive::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 5px;
    background: linear-gradient(to left, rgba(7, 167, 225, 0.2), transparent);
    pointer-events: none;
  }

  /* Style for action buttons column */
  .table td:last-child {
    white-space: nowrap;
    min-width: 100px;
  }

  /* Improve touch targets for mobile */
  .table td a,
  .table td button {
    padding: 8px;
    margin: 2px;
    display: inline-block;
  }

  .vs-icon {
    font-size: 22px !important; /* Larger icons for better touch */
  }
}

/* Add smooth scrolling for all devices */
* {
  scroll-behavior: smooth;
}
</style>
